import { render } from "./StepNavigstion.vue?vue&type=template&id=821bd6f4"
import script from "./StepNavigstion.vue?vue&type=script&lang=js"
export * from "./StepNavigstion.vue?vue&type=script&lang=js"

import "./StepNavigstion.vue?vue&type=style&index=0&id=821bd6f4&lang=css"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__